import React, { Component } from "react";
import _ from 'lodash';
import {Modal, Row, Col, Table} from 'react-bootstrap';
export default class DoubleScreen  extends Component {
  render(){     
    const {object, title} = this.props;
    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w"
      size="xl"
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        Web Form For - {title}
      </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
        <div className='assesmentShow'>  
          <br/>
          <Row className='information'>
            <Col><center>
            <b>TRANSACTION NUMBER</b><br/>
            <span className='colorBlue'>{object.transactionID}
            </span></center>
            </Col>
            <Col><center>
            <b>TRANSACTION DATE</b><br/>
            <span className='colorBlue'>{object.addedDate}
            </span></center>
            </Col>            
            <Col><center>
            <b>WEB FORM NAME</b><br/>
            <span className='colorBlue'>{object.webFormName}
            </span></center>
            </Col>
            <Col><center>
            <b>UPDATED BY</b><br/>
            <span className='colorBlue'>{object.QAName}
            </span></center>
            </Col>         
          </Row>
            
          <Table responsive>
          <thead><tr><th>FIELD NAME</th><th>FIELD VALUE</th></tr></thead>
          <tbody>
          {(!_.isEmpty(object.jsonValues)) ?
            _.map(object.jsonValues, (val, index) => {
            return(
              <tr>
                <td>{val.label}</td>
                <td>{val.value}</td>
              </tr>
            )
          }) : 
          <tr><td colSpan='2'>No Record Found</td></tr>
          }</tbody>
        </Table>
        </div>
        </div>        
      </Modal.Body>
      </Modal>

    )
  }
}